<div class="custom-control custom-checkbox table-checkbox">
  <input
    type="checkbox"
    class="custom-control-input"
    [attr.name]="'itemSelect' + id"
    [attr.id]="'itemSelect' + id"
    (click)="onSelect()"
    [checked]="checked"
  />
  <label class="custom-control-label" [attr.for]="'itemSelect' + id"
    >&nbsp;</label
  >
</div>
